<!-- This icon is from <https://github.com/Templarian/MaterialDesign>, distributed under Apache 2.0 (https://www.apache.org/licenses/LICENSE-2.0) license-->

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40">
        <path d="M 12,0 C 18.6,0 24,5.4 24,12 24,18.6 18.6,24 12,24 5.4,24 0,18.6 0,12 0,5.4 5.4,0 12,0 m 
        0,2.4 C 9.72,2.4 7.68,3.12 6.12,4.44 L 19.56,17.88 C 20.76,16.2 21.6,14.16 21.6,12 21.6,6.72 17.28,2.4 
        12,2.4 M 17.88,19.56 4.44,6.12 C 3.12,7.68 2.4,9.72 2.4,12 c 0,5.28 4.32,9.6 9.6,9.6 2.28,0 4.32,-0.72 5.88,-2.04 z" />
    </svg>
</template>